import {createSlice} from '@reduxjs/toolkit';

import {
  builderDisablePolygonDelivery,
  builderEnablePolygonDelivery,
  builderGetDeliveryCoverage,
  builderGetOwnDeliveryCoverage
} from './reducer';

const initialState: any = {
  loadingDeliveryCoverage: false,
  deliveryCoverageOwnError: '',
  deliveryCoverageExpressError: '',
  deliveryCoverageOwn: undefined,
  deliveryCoverageExpress: undefined,

  enablingPolygonDelivery: false,
  enablePolygonDeliveryError: '',
  enablePolygonDeliveryResponse: undefined,

  disablingPolygonDelivery: false,
  disablePolygonDeliveryError: '',
  disablePolygonDeliveryResponse: undefined
};

export const serviceSlice = createSlice({
  name: 'service',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get delivery coverage
    builderGetDeliveryCoverage(builder);
    builderGetOwnDeliveryCoverage(builder);

    //enable polygon delivery
    builderEnablePolygonDelivery(builder);

    //disable polygon delivery
    builderDisablePolygonDelivery(builder);
  }
});

export default serviceSlice.reducer;
